import { createSlice } from '@reduxjs/toolkit'


const initialState = {
    name: '',
};

export const currentServiceSlice = createSlice({
    name: "currentService",
    initialState,
    reducers: {
        setCurrentService: (state, { payload }) => {
            state = { ...state, name: payload }
        },
    }
});

export const { setCurrentService } = currentServiceSlice.actions;

export default currentServiceSlice.reducer;